import { render } from "./DefaultWarehouseConfirmModal.vue?vue&type=template&id=7dbde474"
import script from "./DefaultWarehouseConfirmModal.vue?vue&type=script&lang=js"
export * from "./DefaultWarehouseConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__